import React, { ReactElement, useMemo } from 'react';

import { FormattedMessage } from 'react-intl';

import { manageOrganizationRoutes } from '../../routes';

import styles from './navigation-manage-menu.module.scss';

import { useUserData } from 'context';
import { PATHS } from 'types';
import { Tab, Tabs } from 'views/components';
import { canAccessManageOrganizationRoute } from 'views/pages/ManageOrganization/manageOrganizationAccess';

const NavigationManageMenu = (): ReactElement => {
  const { user, billingStatus, frozenOrganization } = useUserData();
  const roleName = user?.role.name;
  const isFrozenRecoveryMode =
    billingStatus?.accessStatus === 'FROZEN' || Boolean(frozenOrganization);

  const routes = useMemo(
    () =>
      manageOrganizationRoutes
        .filter(
          route =>
            canAccessManageOrganizationRoute(route, roleName) &&
            (!isFrozenRecoveryMode ||
              route.path === PATHS.MANAGE_ORGANIZATION_USER_MANAGEMENT ||
              route.path === PATHS.MANAGE_ORGANIZATION_SUBSCRIPTION_MANAGEMENT),
        )
        .map(({ path, title }) => ({ path, title })),
    [roleName, isFrozenRecoveryMode],
  );

  return (
    <Tabs className={styles.tabs}>
      {routes.map(route => (
        <Tab key={route.path} id={route.path} to={route.path}>
          <FormattedMessage id={route.title} />
        </Tab>
      ))}
    </Tabs>
  );
};

export { NavigationManageMenu };
